import { StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  subTitleTextStyle: {
    color: Colors.dark_grey,
    fontSize: 16,
    marginTop: 15,
    marginBottom: 15,
  },
});
